import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import { getColumns } from "../internals/data/gridData";
import { CustomGridToolbar } from "./customized-toolbar/CustomGridToolbar";
import { GridApiCommunity } from "@mui/x-data-grid/models/api/gridApiCommunity";
import { useNavigate } from "react-router-dom";

export default function CustomizedDataGrid({
  cvs,
  loading,
  handleDeleteClick,
  handleAddCvClick,
}: {
  cvs: any;
  loading: boolean;
  handleDeleteClick: (cv: any) => void;
  handleAddCvClick: () => void;
}) {
  const apiRef = useGridApiRef<GridApiCommunity>();
  const navigate = useNavigate();
  const columns = getColumns(navigate, handleDeleteClick);

  

  return (
    <DataGrid
      checkboxSelection
      rows={cvs}
      columns={columns}
      loading={loading}
      columnVisibilityModel={{
        cvUId: false,
      }}
      getRowClassName={(params) =>
        params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
      }
      initialState={{
        pagination: { paginationModel: { pageSize: 20 } },
        density: "compact",
      }}
      pageSizeOptions={[10, 20, 50]}
      disableColumnResize
      apiRef={apiRef}
      slots={{
        toolbar: () => (
          <CustomGridToolbar
            apiRef={apiRef}
            handleClickOpen={handleAddCvClick}
          />
        ),
      }}
      slotProps={{
        filterPanel: {
          filterFormProps: {
            logicOperatorInputProps: {
              size: "small",
            },
            columnInputProps: {
              size: "small",
              sx: { mt: "auto" },
              inputProps: {
                sx: { ml: "50px" },
              },
            },
            operatorInputProps: {
              size: "small",
              sx: { mt: "auto" },
            },
            valueInputProps: {
              InputComponentProps: {
                size: "small",
              },
            },
          },
        },
      }}
    />
  );
}
